export default {
  path: '/research-output/articles/:id',
  name: 'article-show',
  props: true,
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  component: () => import('./ArticleShow')
}
